import { withModuleGuard } from './common/components/withModuleGuard'
import Login from "./features/auth/pages/Login";
import companyDomain from "./features/auth/pages/CompanyDomain";
import RecoverCompanyUrl from "./features/auth/pages/RecoverCompanyUrl";
import CompanyProfile from "./features/company/pages/Profile/Show";
import CompanyContract from "./features/company/pages/Contract/Show";
import Company from "./features/company/pages/Dashboard";
import MovementsTotalizerList from "./features/movementsTotalizer/pages/List";
import ProductPricesList from "./features/productPrices/pages/List";
import BillsList from "./features/billingBills/pages/List";
import Consumption from "./features/consumption/pages/Create";
import BillingEventsList from "./features/billingEvents/pages/List";
import UserList from './features/users/pages/List';
import UserCreate from './features/users/pages/Create';
import UserShow from './features/users/pages/Show';
import UserUpdate from './features/users/pages/Update';
import CardCurrentLimitsShow from "./features/cardCurrentLimits/pages/Show";
import RefundCreate from "./features/refund/pages/Create";
import UserActionsHistoryShow from "./features/users/pages/ActionsHistoryShow";
import SupportList from "./features/support/pages/List";
import SupportCreate from "./features/support/pages/Create";
import SupportShow from "./features/support/pages/Show";
import ResetPassword from "./features/auth/pages/ResetPassword";
import BillingEventsWithFiscalDocumentRequirementList from "./features/billing/pages/EventsWithFiscalDocumentRequirement/List";
import BillingEventsWithFiscalDocumentRequirementShow from "./features/billing/pages/EventsWithFiscalDocumentRequirement/Show";
import BillingFiscalDocumentGroupsList from "./features/billing/pages/FiscalDocumentGroups/List";
import BillingFiscalDocumentGroupsShow from "./features/billing/pages/FiscalDocumentGroups/Show";
import BillingBillsShow from "./features/billingBills/pages/Show";
import ReportsPermittedReports from "./features/reports/pages/PermittedReports";
import ReportsSubmit from "./features/reports/pages/Submit";
import PaymentAdvanceList from "./features/paymentAdvances/pages/List";
import PaymentAdvanceShow from "./features/paymentAdvances/pages/Show";
import PaymentAdvanceCreate from "./features/paymentAdvances/pages/Create";
import NegotiationsList from "./features/negotiations/pages/List";
import NegotiationsShow from "./features/negotiations/pages/Show";
import AccessDenied from "./features/auth/pages/AccessDenied";
import { NotFoundMobileScreen, NotFoundPage } from "./common/components/NotFoundErrorMessage";
import TefConfigurationsList from "./features/tefConfigurations/pages/List";
import FailedConsumptionsList from "./features/failedConsumptions/pages/List";
import MobileHome from "./common/mobile/Home";
import ConsumptionCreateMobile from "./features/consumption/pages/Create/mobile";
import CardCurrentLimitsShowMobile from "./features/cardCurrentLimits/pages/Show/mobile";
import RefundCreateMobile from "./features/refund/pages/Create/mobile";
import TmaisUsers from "./features/tmaisUsers/pages/List";
import TmaisUsersShow from "./features/tmaisUsers/pages/Show";
import MissionsList from "./features/missions/pages/List";
import MissionsCreate from "./features/missions/pages/Create";
import MissionsEdit from "./features/missions/pages/Edit";
import MissionsShow from "./features/missions/pages/Show";
import TmaisRewardItems from "./features/rewardItems/pages/List";
import TmaisRewardItemsCreate from "./features/rewardItems/pages/Create";
import TmaisRewardItemsShow from "./features/rewardItems/pages/Show";
import TmaisRewardItemsUpdate from "./features/rewardItems/pages/Update";
import TmaisRafflesList from "./features/tmaisRaffles/pages/List";
import TmaisRafflesShow from "./features/tmaisRaffles/pages/Show";
import TmaisRafflesCreate from "./features/tmaisRaffles/pages/Create";
import TmaisRafflesUpdate from "./features/tmaisRaffles/pages/Update";
import MaintenanceWorkflowsList from "./features/maintenance/features/workflows/pages/List";
import MaintenanceWorkflowsShow from "./features/maintenance/features/workflows/pages/Show";
import MaintenanceWorkflowDiagnosticEntryUpdate from "./features/maintenance/features/workflows/features/diagnosticEntry/screens/Update";
import MaintenanceWorkflowExecutionEntryUpdate from "./features/maintenance/features/workflows/features/executionEntry/screens/Update";
import MaintenanceWorkflowExecutionEntryExecution from "./features/maintenance/features/workflows/features/executionEntries/screens/Execution";
import MaintenanceWorkflowFiscalAssessmentEntryUpdate from "./features/maintenance/features/workflows/features/fiscalAssessmentEntries/screens/Update";
import AnpReportsList from './features/anpReports/pages/List';
import AnpReportsShow from './features/anpReports/pages/Show';
import AnpHistoricalReportsList from './features/anpReports/pages/HistoricalList';
import AnpHistoricalReportsShow from './features/anpReports/pages/HistoricalShow';

export const publicRoutes = [
  { path: '/', comp: companyDomain },
  { path: '/recover-company-domain', comp: RecoverCompanyUrl },
  { path: '/access-denied', comp: AccessDenied },
];

export const publicCompanyRoutes = [
  { path: '/login', comp: Login },
  { path: '/reset-password', comp: ResetPassword },
]

export const privateCompanyRoutes = [
  { path: '/*', comp: NotFoundPage },

  { path: '/company', comp: Company },
  { path: '/company/mine', comp: CompanyProfile },
  { path: '/company/mine/contract', comp: CompanyContract },

  // reports
  { path: '/reports', comp: ReportsPermittedReports },
  { path: '/reports/create', comp: ReportsSubmit },

  // anp reports
  { path: '/anp-reports', comp: AnpReportsList },
  { path: '/anp-reports/:id/*', comp: AnpReportsShow },
  { path: '/anp-historical-reports', comp: AnpHistoricalReportsList },
  { path: '/anp-historical-reports/:id/*', comp: AnpHistoricalReportsShow },

  { path: '/billing-events', comp: BillingEventsList },
  { path: '/movements-totalizer', comp: MovementsTotalizerList },
  { path: '/billing-bills', comp: BillsList },
  { path: '/billing-bills/:id/*', comp: BillingBillsShow },
  { path: '/failed-transactions', comp: FailedConsumptionsList },

  { path: '/product-prices', comp: ProductPricesList },

  { path: '/consumption', comp: Consumption },
  { path: '/card-current-limit', comp: CardCurrentLimitsShow },
  { path: '/refund', comp: RefundCreate },

  { path: '/users', comp: UserList },
  { path: '/users/create', comp: UserCreate },
  { path: '/users/:id/edit', comp: UserUpdate },
  { path: '/users/:id/actionsHistory/:requestId', comp: UserActionsHistoryShow },
  { path: '/users/:id/*', comp: UserShow },

  { path: '/support', comp: SupportList },
  { path: '/support/create', comp: SupportCreate },
  { path: '/support/:id', comp: SupportShow },

  // events with fiscal document requirement
  { path: '/events-with-fiscal-document-requirement', comp: BillingEventsWithFiscalDocumentRequirementList },
  { path: '/events-with-fiscal-document-requirement/:id', comp: BillingEventsWithFiscalDocumentRequirementShow },

  // fiscal document groups
  { path: '/billing-fiscal-document-groups', comp: BillingFiscalDocumentGroupsList },
  { path: '/billing-fiscal-document-groups/:id', comp: BillingFiscalDocumentGroupsShow },

  { path: '/payment-advances', comp: PaymentAdvanceList },
  { path: '/payment-advances/:id', comp: PaymentAdvanceShow },
  { path: '/payment-advances/:billId/create', comp: PaymentAdvanceCreate },

  // negotiations
  { path: '/negotiations', comp: NegotiationsList },
  { path: '/negotiations/:id', comp: NegotiationsShow },

    // missions
  { path: '/tmais-missions', comp: MissionsList },
  { path: '/tmais-missions/new', comp: MissionsCreate },
  { path: '/tmais-missions/:id', comp: MissionsShow },
  { path: '/tmais-missions/:id/edit', comp: MissionsEdit },


  // tef configurations
  { path: '/tef-configurations/:provider', comp: TefConfigurationsList },

  // tmais reward items
  { path: '/tmais-reward-items', comp: withModuleGuard('tmais_module_enabled', TmaisRewardItems) },
  { path: '/tmais-reward-items/create', comp: withModuleGuard('tmais_module_enabled', TmaisRewardItemsCreate) },
  { path: '/tmais-reward-items/:id', comp: withModuleGuard('tmais_module_enabled', TmaisRewardItemsShow) },
  { path: '/tmais-reward-items/:id/edit', comp: withModuleGuard('tmais_module_enabled', TmaisRewardItemsUpdate) },

  // tmais raffles
  { path: '/tmais-raffles', comp: withModuleGuard('tmais_module_enabled', TmaisRafflesList) },
  { path: '/tmais-raffles/:id', comp: withModuleGuard('tmais_module_enabled', TmaisRafflesShow) },
  { path: '/tmais-raffles/create', comp: withModuleGuard('tmais_module_enabled', TmaisRafflesCreate) },
  { path: '/tmais-raffles/:id/edit', comp: withModuleGuard('tmais_module_enabled', TmaisRafflesUpdate) },

  // tmais users
  { path: '/tmais-users', comp: withModuleGuard('tmais_module_enabled', TmaisUsers) },
  { path: '/tmais-users/:id/*', comp: withModuleGuard('tmais_module_enabled', TmaisUsersShow) },

  // maintenance-workflows
  { path: '/maintenance-workflows', comp: withModuleGuard('cm_module_enabled', MaintenanceWorkflowsList) },
  { path: '/maintenance-workflows/:id/*', comp: withModuleGuard('cm_module_enabled', MaintenanceWorkflowsShow) },
  { path: '/maintenance-workflows/:workflowId/diagnostic-entry/:forwardingId', comp: withModuleGuard('cm_module_enabled', MaintenanceWorkflowDiagnosticEntryUpdate) },
  { path: '/maintenance-workflows/:workflowId/execution-entry/:forwardingId', comp: withModuleGuard('cm_module_enabled', MaintenanceWorkflowExecutionEntryUpdate) },
  { path: '/maintenance-workflows/:workflowId/execution-entry/:forwardingId/execution', comp: withModuleGuard('cm_module_enabled', MaintenanceWorkflowExecutionEntryExecution) },
  { path: '/maintenance-workflows/:workflowId/fiscal-assessment-entry/:forwardingId', comp: withModuleGuard('cm_module_enabled', MaintenanceWorkflowFiscalAssessmentEntryUpdate) },
];

export const mobilePublicRoutes = [
  { path: '/', comp: companyDomain },
  { path: '/recover-company-domain', comp: RecoverCompanyUrl },
  { path: '/access-denied', comp: AccessDenied },
];

export const mobilePublicCompanyRoutes = [
  { path: '/login', comp: Login },
  { path: '/reset-password', comp: ResetPassword },
];

export const mobilePrivateCompanyRoutes = [
  { path: '/*', comp: NotFoundMobileScreen },
  { path: '/home', comp: MobileHome },
  { path: '/consumption', comp: ConsumptionCreateMobile },
  { path: '/card-current-limit', comp: CardCurrentLimitsShowMobile },
  { path: '/refund', comp: RefundCreateMobile },
];
